import GoalEdit from './GoalEdit';

export default GoalEdit;
